import { render, staticRenderFns } from "./CsimSchemaAttributeForm.vue?vue&type=template&id=e71c38d8"
import script from "./CsimSchemaAttributeForm.vue?vue&type=script&lang=js"
export * from "./CsimSchemaAttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports